var React = require('react');

function LinkedinIcon (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"12","cy":"12","r":"12","fill":"#BDBDBD","key":0}),React.createElement("path",{"d":"M9.33647 16.68V10.5609H7.5007V16.68H9.33647ZM9.33647 8.37548C9.33647 7.82912 8.97652 7.42847 8.36459 7.42847C7.82466 7.42847 7.42871 7.82912 7.42871 8.37548C7.42871 8.92183 7.78867 9.32249 8.36459 9.32249C8.97652 9.35891 9.33647 8.92183 9.33647 8.37548ZM12.3961 16.68V13.1834C12.3961 13.0013 12.3961 12.8191 12.4681 12.6734C12.6121 12.3092 12.936 11.9086 13.512 11.9086C14.2679 11.9086 14.6998 12.3456 14.6998 13.1834V16.68H16.5716V13.1105C16.5716 11.1801 15.5637 10.3059 14.2319 10.3059C13.116 10.3059 12.6481 10.9251 12.3601 11.3622V10.5609H10.5243C10.5603 11.1437 10.5243 16.7164 10.5243 16.7164H12.3961V16.68Z","fill":"white","key":1})]);
}

LinkedinIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = LinkedinIcon;

LinkedinIcon.default = LinkedinIcon;
